import * as React from 'react'
import { X } from '@phosphor-icons/react'

type ConfirmationModalProps = {
  title: string
  description: string
  confirmLabel: string
  cancelLabel?: string
  confirmVariant?: 'primary' | 'danger'
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  onClose,
  onConfirm,
}) => {
  const confirmClass =
    confirmVariant === 'danger'
      ? 'bg-[#E42309] text-white hover:bg-[#cc1f08]'
      : 'bg-[#1D264A] text-white hover:bg-[#2A3566]'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(29,38,74,0.22)] px-4">
      <div className="relative w-full max-w-[756px] rounded-[24px] bg-white px-11 pt-12 pb-11 shadow-[0_18px_44px_rgba(29,38,74,0.18)]">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-11 top-11 inline-flex h-[44px] w-[44px] items-center justify-center rounded-[32px] bg-[#E7EAF4] text-[#5E6580] hover:bg-[#E3E8F1]"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        <h3 className="font-talent mb-4 max-w-[520px] pr-16 text-[23px] font-medium leading-[28px] text-[#1D264A]">
          {title}
        </h3>

        <p className="font-talent mb-10 text-[16px] font-normal leading-[20px] text-[#5E6580]">
          {description}
        </p>

        <div className="flex items-center justify-end gap-3">
          {confirmVariant === 'danger' ? (
            <>
              <button
                type="button"
                onClick={onConfirm}
                className={`font-talent inline-flex h-[40px] items-center justify-center rounded px-6 text-[16px] font-medium ${confirmClass}`}
              >
                {confirmLabel}
              </button>

              <button
                type="button"
                onClick={onClose}
                className="font-talent inline-flex h-[40px] items-center justify-center rounded px-6 text-[16px] font-medium text-[#1D264A] hover:bg-[#F7F8FB]"
                style={{ border: '1px solid #1D264A' }}
              >
                {cancelLabel}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={onClose}
                className="font-talent inline-flex h-[40px] items-center justify-center rounded px-6 text-[16px] font-medium text-[#1D264A] hover:bg-[#F7F8FB]"
                style={{ border: '1px solid #1D264A' }}
              >
                {cancelLabel}
              </button>

              <button
                type="button"
                onClick={onConfirm}
                className={`font-talent inline-flex h-[40px] items-center justify-center rounded px-6 text-[16px] font-medium ${confirmClass}`}
              >
                {confirmLabel}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
